import * as types from './types';
import { loading } from 'State/actions';
import { toastType, createToast } from 'Common/ToastHelper';
import { has } from 'lodash';

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CHARGES_AND_PREPAYMENTS_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/ChargesAndPrepaymentsReport',
        data
      );

      if (!response.data.Data) {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        dispatch({
          type: types.CHARGES_AND_PREPAYMENTS_REPORT,
          payload: response.data.Data,
        });
      }
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.CHARGES_AND_PREPAYMENTS_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      }
    }

    dispatch(loading(types.CHARGES_AND_PREPAYMENTS_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.CHARGES_AND_PREPAYMENTS_REPORT,
    payload: null,
  };
};

export const getUsers = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CHARGES_AND_PREPAYMENTS_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'Usermaster/TransactionedUsers'
      );
      dispatch({
        type: types.CHARGES_AND_PREPAYMENTS_GET_USERS,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.CHARGES_AND_PREPAYMENTS_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      }
    }

    dispatch(loading(types.CHARGES_AND_PREPAYMENTS_FETCHING, false));
  };
};

export const updateStatus = (status, checked) => {
  return {
    type: types.CHARGES_AND_PREPAYMENTS_SET_STATUS,
    payload: { status, checked },
  };
};

export const toggleAllStatuses = () => {
  return {
    type: types.CHARGES_AND_PREPAYMENTS_TOGGLE_ALL_STATUSES,
    payload: {},
  };
};

export const clearErrors = () => {
  return {
    type: types.CHARGES_AND_PREPAYMENTS_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/chargesandprepaymentsreport/state/chargesandprepaymentsreport/actions.js